<div [class]="'progress-circle progress-circle-'+slices" >
  <div *ngFor="let slice of slicesArray; let i = index" [ngStyle]="{'transform': 'rotate(' + (i * 360 / slices) + 'deg)'}" [ngClass]="{'slice': true, 'fill': i < filledSlices }" ></div>
  <div class="inner"></div>
  <div class="number" [ngClass]="{'alert':filledSlices === 0}">{{number}}</div>
</div>

